var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.9976 46.9326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "minus_iconElement 168") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Isolationsmodus_Kopie",
    "data-name": "Isolationsmodus Kopie"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.97868,24.167A23.1415,23.1415,0,0,1,23.41227,46.9326q-.46,0-.92383-.0166A22.904,22.904,0,0,1,6.28922,39.30174,24.02976,24.02976,0,0,1,.03727,21.85838C.7443,9.39451,12.07047-.60256,24.78629.0283A22.85489,22.85489,0,0,1,46.97868,24.167Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.746,24.70408A220.61144,220.61144,0,0,0,12.25053,24.538c-1.45008.06323-1.44226-2.18714,0-2.25a220.61144,220.61144,0,0,1,22.49548.16613C36.18766,22.53831,36.19254,24.78856,34.746,24.70408Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus_icon.365dc2944af18e1ee77434810995e156.svg";
export { ForwardRef as ReactComponent };